import QuestionnaireChoiceStep from "pages/application/templates/shared/QuestionnaireChoiceStep";
import "./single-choice.scss";
import { NextStepActionResponse } from "pages/application/applicationService";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";

interface Accumulator {
  normalStepActions: NextStepActionResponse[];
  otherButton: NextStepActionResponse | null;
  otherText: NextStepActionResponse | null;
}

export const splitNormalAndOtherStepActions = (stepActions: NextStepActionResponse[]) => {
  return stepActions.reduce(
    (acc: Accumulator, stepAction: NextStepActionResponse) => {
      if (stepAction.actionType === "otherButton") {
        acc.otherButton = stepAction;
      } else if (stepAction.actionType === "otherText") {
        acc.otherText = stepAction;
      } else {
        acc.normalStepActions.push(stepAction);
      }
      return acc;
    },
    { normalStepActions: [], otherButton: null, otherText: null }
  );
};

const optionsAsButtonsMaximun = 7;
export const shouldShowOptionsAsDropdown = (stepActions: NextStepActionResponse[]) => stepActions.length >= optionsAsButtonsMaximun;

const SingleChoice = () => {
  const stepData = useSelector(getStepData);
  const stepCode = stepData.stepCodeText;
  const disclaimer = stepData.disclaimer;
  const skipAction = stepData.skipAction;
  const stepLabel = stepData.label;

  const { normalStepActions, otherButton, otherText } = splitNormalAndOtherStepActions(
    [...stepData.nextStepActions].sort((a, b) => a.presentationOrder - b.presentationOrder)
  );

  const showOptionsAsDropdown = shouldShowOptionsAsDropdown(normalStepActions);

  return (
    <div className={`single-choice ${showOptionsAsDropdown ? "single-choice-dropdown" : ""}`}>
      <QuestionnaireChoiceStep
        stepActions={normalStepActions}
        stepCode={stepCode}
        stepLabel={stepLabel}
        skipAction={skipAction}
        disclaimer={disclaimer}
        otherButton={otherButton}
        otherText={otherText}
        showAsDropdown={showOptionsAsDropdown}
      />
    </div>
  );
};

export default SingleChoice;
